/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

/**
 * @author stcatai Mar 22, 2024
 */
export enum DetectionSystem {
  Offline = "Offline",
  RTRD = "RTRD",
  SQL = "SQL",
  RD_SELF_SERVICE = "RD_SELF_SERVICE"
}